/**
 * Docs: https://www.notion.so/famly/Intercom-Events-8527f26d693b4489aa33219e4dee8710
 *
 * Reminder:
 * Add/update docs for new/updated events in Notion: https://www.notion.so/famly/de829a628dc149d5aa73fb401e32ab10?v=e75775bd60de4614acc14e840cd2b1cf.
 * This is important so that non-engineers can clearly understand what each event represents.
 */

import {checkIfFlagIsToggled} from 'web-app/react/routes/debugger/local-storage-config';

export enum EventName {
    ACCIDENT_CREATED = 'Accident created',
    ATTENDANCE_SCHEDULES_NEW_SCHEDULE_BUTTON_CLICKED = 'Attendance schedules: New schedule button clicked',
    CHILD_ADDED = 'New child added',
    CHILD_SIGNED_IN = 'Child signed in',
    EMPLOYEE_ADDED = 'New employee added',
    PARENT_ADDED = 'New parent added',
    PARENT_INVOICED = 'Parent invoiced',
    PARENT_INVOICED_INVOICING_PAGE = 'PARENT_INVOICED_INVOICING_PAGE',
    PARENTAL_PERMISSION_CREATED = 'Parental permission created',
    FEED_POST_CREATED = 'New feed post created',
    SESSION_ADDED = 'New session added',
    ROOM_ADDED = 'New room added',
    OBSERVATION_ADDED = 'New observation added',
    OBSERVATION_ADDED_CHILD_DEVELOPMENT = 'New observation added (Child development)',
    PLAN_ADDED = 'New plan added',
    PLAN_ADDED_TO_CHILD = 'New plan added to child',
    STARTER_TRIAL_STARTED = 'New starter trial started',
    ESSENTIALS_TRIAL_STARTED = 'New essentials trial started',
    PREMIUM_TRIAL_STARTED = 'New premium trial started',
    PROFESSIONAL_TRIAL_STARTED = 'New professional trial started',
    CHILDMINDER_TRIAL_STARTED_NEW_FREE = 'New childminder trial started: new free',
    CHILDMINDER_TRIAL_STARTED_OLD_FREE = 'New childminder trial started: old free',
    NPS_SCORE_SUBMITTED = 'New nps score submitted',
    FINANCE_ONBOARDING_WIZARD_COMPLETED = 'Finance onboarding wizard completed',
    FINANCE_ONBOARDING_WIZARD_EXIT_FLOW = 'Finance onboarding wizard flow exited',
    NEW_BOOKING_PATTERN_BUILDER_SAVED = 'New booking pattern builder saved',
    FAMLY_HOME_VISITED = 'Famly Home visited',
    UK_PACKAGE_PURCHASE_STARTER = 'UK Starter Package Purchased In-App',
    UK_PACKAGE_PURCHASE_ESSENTIALS = 'UK Essentials Package Purchased In-App',
    UK_PACKAGE_PURCHASE_PREMIUM = 'UK Premium Package Purchased In-App',
    PAYMENT_REMINDER_SENT = 'Payment reminder sent',
    PASSWORD_CREATED = 'Password created',
    NURSERY_INFORMATION_UPDATED = 'Nursery information updated',
    BILL_PAYER_ADDED = 'Bill payer added',
    ENQUIRY_ADDED = 'Enquiry added',
    ACTIVITY_ADDED = 'Activity added',
    BULK_BONBOARDING_SAVED = 'Bulk bonboarding flow completed',
    BONBOARDING_DROP_OFF = 'Bonboarding: User dropped off without finishing flow',
    STAFF_ATTENDANCE_EMPLOYEE_WEEK_MODAL_OPENED = 'Staff attendance employee week modal opened',
    FAMLY_HOME_FAMLY_PAY_INFORM_PARENTS_CLICKED = 'Famly pay - clicked Inform parents',
    FAMLY_HOME_FAMLY_PAY_REMIND_PARENTS_CLICKED = 'Famly pay - clicked Remind parents',
    FAMLY_HOME_FAMLY_PAY_CLAIM_CLICKED = 'Famly pay - clicked Claim',
    FEATURE_STORE_REQUEST_FREE_PACKAGE_UPGRADE = 'Feature store - request free package upgrade',
    FEATURE_STORE_IN_APP_UPGRADE = 'Feature store - In-app upgrade',
    FEATURE_STORE_IN_APP_UPGRADE_OLD_FREE_CHILDMINDER = 'Feature store - In-app upgrade: old free to childminder',
    FEATURE_STORE_IN_APP_UPGRADE_NEW_FREE_CHILDMINDER = 'Feature store - In-app upgrade: new free to childminder',
    FEATURE_STORE_IN_APP_UPGRADE_NEW_FREE_TIER_1_GROW = 'Feature store - In-app upgrade: new free to Tier 1 Grow',
    FEATURE_STORE_IN_APP_UPGRADE_NEW_FREE_TIER_1_SIMPLIFY = 'Feature store - In-app upgrade: new free to Tier 1 Simplify',
    FEATURE_STORE_IN_APP_UPGRADE_NEW_FREE_TIER_1_ENGAGE = 'Feature store - In-app upgrade: new free to Tier 1 Engage',
    FEATURE_STORE_IN_APP_UPGRADE_NEW_FREE_TIER_1_LEARN = 'Feature store - In-app upgrade: new free to Tier 1 Learn',
    FEATURE_STORE_IN_APP_UPSELL = 'Feature store - In-app upsell',
    FAMLY_STORE_PURCHASE_FLOW_DROPOFF = 'Famly Store: Purchase flow drop-off',
    EMPLOYEE_SIGNED_IN = 'Employee signed in',
    EMPLOYEE_SIGNED_OUT = 'Employee signed out',
    EMPLOYEE_LEAVE_CREATED = 'Employee leave created',
    EMPLOYEE_LEAVE_APPROVED = 'Employee leave approved',
    CRF_FORM_MANAGEMENT_PAGE_OPENED = 'CRF form page opened',
    CRF_FORM_EMPTY_MANAGEMENT_PAGE_OPENED = 'CRF empty form page opened',
    CRF_FORM_PAGE_FORM_BUILDER_OPENED = 'CRF form builder opened',
    SIDEKICK_SUGGEST_PROMPT = 'Sidekick suggest prompt clicked',
    ROOMS_CUSTOM_STATUSES_NEW_CUSTOM_STATUS_ADDED = 'New custom status added',
    PARENTS_PERMISSONS_NEW_PERMISSION_ADDED = 'New parental permission added',
    FAMLY_HOME_NEW_TAG_ADDED = 'New tag added',
    PAYMENTS_XERO_CSV_FILE_EXPORTED = 'Payments - xero CSV file exported',
    REVENUE_BUDGETING_TARGET_ADDED = 'Revenue - budgeting target added',

    SALES_TO_CS_FLOW_GET_STARTED_CLICKED = 'Sales to CS flow: Get started clicked',

    BUY_NOW_BANNER_TALK_TO_US_LINK_CLICKED = 'Talk to Us clicked: Buy Now Banner',

    // Test child actions
    TEST_CHILD_ACTIONS_SIGN_IN_TEST_CHILD = 'Test child actions - Sign in test child',
    TEST_CHILD_ACTIONS_ADD_NAP = 'Test child actions - Add a nap',
    TEST_CHILD_ACTIONS_FINISH_ASSESSMENT = 'Test child actions - Finish baseline assessment',
    TEST_CHILD_ACTIONS_FINISH_ACCIDENT_REPORT = 'Test child actions - Finish an accident report',
    TEST_CHILD_ACTIONS_FINISH_NEWSFEED_POST_DRAFT = 'Test child actions - Finish news feed post draft',
    TEST_CHILD_ACTIONS_REVIEW_SEND_OBSERVATION = 'Test child actions - Review and send an observation',
    TEST_CHILD_ACTIONS_MODAL_DISMISSED = 'Test child actions - Modal dismissed',
    // Test child action success
    TEST_CHILD_SIGN_IN_ACTION_SUCCESS = 'Test child - Sign-in action success',
    TEST_CHILD_SLEEP_ACTION_SUCCESS = 'Test child - Add nap action success',
    TEST_CHILD_ASSESSMENT_ACTION_SUCCESS = 'Test child - Assessment action success',
    TEST_CHILD_OBSERVATION_ACTION_SUCCESS = 'Test child - Observation action success',
    TEST_CHILD_NEWS_FEED_ACTION_SUCCESS = 'Test child - News feed action success',
    TEST_CHILD_ACCIDENT_REPORT_ACTION_SUCCESS = 'Test child - Accident report action success',

    // Meal plans
    MEAL_PLAN_END_REACHED_CONTACT_SUPPORT = 'Meal plans - End reached contact support',
    MEAL_PLANS_NEW_MEAL_PLAN_ADDED = 'Meal plans - New meal plan added',

    // Self signup
    EXISTING_USER_SELF_SIGNUP = 'Existing user self signup',

    // Child profile
    CHILD_PROFILE_VISITED = 'Child profile visited',
    CHILD_PROFILE_MODAL_OPENED = 'Child profile modal opened',

    // New child modal (rolled out as part of the Family tab)
    ADD_CHILD_FLOW_OPENED = 'Add Child flow opened',

    // Learning
    LEARING_ACTIVITY_PLAN_ADDED = 'Learning - activity plan added',

    // Sessions
    SCHEDULE_SESSION_CHANGE_CLICKED = 'Sessions - Schedule session change clicked',

    // Setup guide
    SETUP_GUIDE_BASICS_CATEGORY_COMPLETED = 'Setup Guide: Basics category completed',
    SETUP_GUIDE_LEARNING_CATEGORY_COMPLETED = 'Setup Guide: Learning category completed',
    SETUP_GUIDE_FINANCE_CATEGORY_COMPLETED = 'Setup Guide: Finance category completed',
    SETUP_GUIDE_ATTENDANCE_CATEGORY_COMPLETED = 'Setup Guide: Attendance category completed',
    SETUP_GUIDE_COMMUNICATION_CATEGORY_COMPLETED = 'Setup Guide: Communication category completed',

    // Sidekick
    SIDEKICK_TRIAL_STARTED = 'Sidekick trial: started',

    // Onboarding Proactive Support: Growth no-code initiative
    ADD_CHILD_FLOW_DROPOUT = 'Add child flow drop out',
    BATCH_INVOICES_SENT_OUT = 'Batch Invoices sent out',
    ADD_CHILD_PLAN_FLOW_DROPOUT = 'Add child plan flow drop out',
    TEST_CHILD_PROFILE_VISITED = 'Test child profile visited',
    ADD_MEAL_PLAN_FLOW_DROPOUT = 'Add meal plan flow drop out',
    ADD_STAFF_SCHEDULE_FLOW_DROPOUT = 'Add staff schedule flow drop out',
    TEST_CHILD_PARENT_ADDED = 'Test child parent added',
}

export const triggerIntercomEvent = (eventName: EventName, metadata?: object) => {
    if (checkIfFlagIsToggled('TRACKING_VISUALIZATION')) {
        // eslint-disable-next-line no-console
        console.log(`Intercom event: ${eventName}`);
    }
    if (window.Intercom) {
        window.Intercom('trackEvent', eventName, metadata);
    }
};
